// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Vtxf","title":"Header_title__39MnZ","side":"Header_side__3-F2E"};